import { RefObject, use } from 'react'

import { fetchAccounts } from '@app/api/accounts/fetchAccounts'

import { getUniqueArray } from '@lib/utils'

import { ChatState } from './useChatState'
import { fetchListings } from '../api'
import { ChatContext } from '../context'
import { getDependenciesIDs } from '../helpers'
import { Conversation, ConversationItem } from '../models'
import { getUserLanguage } from '../utils'

export const useDependencies = (refState?: RefObject<ChatState>) => {
  const { state } = use(ChatContext)

  const getDependencies = async (
    conversations: Array<Conversation | ConversationItem>
  ) => {
    const language = getUserLanguage()
    const dependenciesIDs = getDependenciesIDs(conversations)

    const listingsIDs = dependenciesIDs.listings.filter((id) => {
      if (refState?.current) {
        return !refState?.current.listings.has(id)
      }

      return !state.listings.has(id)
    })

    const accountIds = conversations.reduce(
      (accumulator: number[], conversation) => {
        if (
          conversation.contactAccountId &&
          !refState?.current?.accounts.has(conversation.contactAccountId)
        ) {
          accumulator.push(conversation.contactAccountId)
        }

        return accumulator
      },
      []
    )

    const [listings, accounts] = await Promise.all([
      fetchListings(listingsIDs, language).catch((error) => {
        console.error('Failed to fetch listing dependencies', error)
        return []
      }),
      fetchAccounts(getUniqueArray(accountIds)).catch((error) => {
        console.error('Failed to fetch account dependencies', error)
        return []
      }),
    ])

    return {
      listings,
      accounts,
    }
  }

  return {
    getDependencies,
  }
}
